import React, { Component } from 'react';
import { connect } from 'shalala';
import * as qs from 'query-string';

import './Activation.css';
import { Auth } from '../../support';
import { useStore } from '../../store';
import LoadingButton from '../../facturotopia/LoadingButton';

class ConfigConfirmation extends Component {
  state = {
    data: {},
  };

  constructor(props) {
    super(props);

    const { cliente } = Auth.getData();

    this.state = {
      activation: cliente.config.activation || {},
    };
  }

  componentWillUnmount() {
    this.props.validationActions.reset();
    this.props.verificationActions.reset();
  }

  handleOnEmailResend = async (step) => {
    await this.props.verificationActions.verify();

    const { data } = this.props.verification;

    if (!!data && data.code === 'user_confirmed') {
      this.updateInternalChecklistEmailConfirmation();
    }
  };

  handleOnEmailVerfied = async () => {
    await this.props.validationActions.verify();

    const { data } = this.props.validation;

    if (data.code === 'user_confirmed') {
      this.updateInternalChecklistEmailConfirmation();
    }

    window.ToastManager.show({
      title: 'Validación',
      message: data.message,
    });
  };

  updateInternalChecklistEmailConfirmation() {
    const original = Auth.getData();
    const { cliente } = original;
    const { config } = cliente;

    const data = {
      ...original,
      cliente: {
        ...cliente,
        config: {
          ...config,
          activation: {
            ...config.activation,
            email_confirm: true,
          },
        },
      },
    };

    Auth.setData(data);

    const query = qs.parse(this.props.location.search);

    setTimeout(() => {
      if (!!query.intro) {
        this.props.history.replace('/app/intro');
      } else {
        this.props.history.replace('/cuenta/config/activacion');
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  }

  render() {
    const { busy: validating } = this.props.validation;
    const { busy: sending, data: verify } = this.props.verification;

    return (
      <>
        <div className="py-3">
          <strong className="text-info">VERIFICACIÓN DE CUENTA</strong>
        </div>

        <div className="py-3">
          Para pasar al modo <strong>LIVE</strong> y emitir facturas con validéz fiscal es necesario que nos confirmes
          tu correo electrónico, será usado únicamente con fines comerciales y jamás te enviaremos correo no deseado.
        </div>

        <div>
          <p>No has recibido el correo de verificación de cuenta?</p>

          {!!verify && !!verify.message && <p className="text-success">{verify.message}</p>}

          <LoadingButton
            loading={sending}
            onClick={this.handleOnEmailResend}
          >
            Reenviar nuévamente
          </LoadingButton>

          <p className="pt-3">Ya verificaste tu cuenta?</p>

          <LoadingButton
            loading={validating}
            onClick={this.handleOnEmailVerfied}
          >
            Actualizar
          </LoadingButton>
        </div>
      </>
    );
  }
}

const mapState = (store) => {
  return {
    validation: store.cuenta.configuracion.validation,
    verification: store.cuenta.configuracion.verification,
  };
};

const mapActions = (actions) => {
  return {
    validationActions: actions.cuenta.configuracion.validation,
    verificationActions: actions.cuenta.configuracion.verification,
  };
};

export default connect(useStore, mapState, mapActions)(ConfigConfirmation);
